<bic-popup (close)="close()" [hasBackdrop]="true" [title]="'Verknüpfung mit SharePoint lösen?'" customClass="w-[560px] h-fit">
  <div bicPopupContent class="flex flex-col gap-3">
    <span class="text-sm text-gray-900">
      „{{ data.link.folderPath }}“ wird danach nicht mehr synchronisiert. In SharePoint ändert sich nichts.
    </span>
    <label class="flex flex-row gap-3 p-3 rounded-lg border cursor-pointer"
           [class.border-green]="mode === 'KEEP_FILES'" [class.border-gray-200]="mode !== 'KEEP_FILES'">
      <input type="radio" name="mode" value="KEEP_FILES" [(ngModel)]="mode" class="mt-1 text-green focus:ring-0">
      <div class="flex flex-col">
        <span class="text-sm text-gray-900">Dateien behalten</span>
        <span class="text-sm text-gray-500">Die übernommenen Dateien bleiben als normale, bearbeitbare planBIC-Dateien.</span>
      </div>
    </label>
    @if (data.canDelete) {
      <label class="flex flex-row gap-3 p-3 rounded-lg border cursor-pointer"
             [class.border-green]="mode === 'TRASH_FILES'" [class.border-gray-200]="mode !== 'TRASH_FILES'">
        <input type="radio" name="mode" value="TRASH_FILES" [(ngModel)]="mode" class="mt-1 text-green focus:ring-0">
        <div class="flex flex-col">
          <span class="text-sm text-gray-900">Ordner in den Papierkorb</span>
          <span class="text-sm text-gray-500">Der Ordner und alle übernommenen Dateien wandern in den Papierkorb.</span>
        </div>
      </label>
    }
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
    <bic-button buttonType="white" (onClick)="close()">Abbrechen</bic-button>
    <bic-button buttonType="red" [loading]="busy" [disabled]="busy" (onClick)="unlink()">Verknüpfung lösen</bic-button>
  </div>
</bic-popup>
